<template>
  <div class="page-content sale-weekly">
    <h1 class="page-title">{{ $locale("sideMenu.reports.filmRevenueWeekly") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="6">
        <CommDatePicker
          v-model="filter.date"
          :value.sync="filter.date"
          width="100%"
          :showWeekly="true"
          :stepByWeekly="true"
        />
      </el-col>
      <el-col :span="6">
        <el-select v-model="filter.filmId" :placeholder="$locale('report.saleWeekly.chooseMovie')" filterable remote>
          <el-option
            v-for="item in filmOption"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select v-model="filter.versions" :placeholder="$locale('report.saleWeekly.allScreen')" multiple>
          <el-option
            v-for="item in versionOption"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="search-area">
      <el-col :span="6">
        <el-select v-model="filter.subtitlesVersions" :placeholder="$locale('trans.report.version.caption.placeholder')" multiple>
          <el-option
            v-for="item in subtitlesVersionOption"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select v-model="filter.otherVersions" :placeholder="$locale('trans.report.version.other.placeholder')" multiple @change="selectOtherVersionsHandler">
          <el-option
            v-for="item in [{ id: 'none', name: 'その他バージョンなし'}, ...otherVersionOption]"
            :label="item.name"
            :value="item.id"
            :key="item.id"
            :disabled="filter.otherVersions.indexOf('none') > -1 && item.id !== 'none'"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="search-area">
      <el-col :span="24" class="ta-r">
        <el-button class="egl-btn-yellow" @click="exportCSV">{{ $locale("global.exportToCSV") }}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
    <div class="checkbox-group">
      <!-- do some thing -->
      <el-checkbox v-model="filter.displayNoTicketType" @change="search_fn">取引のない券種を表示</el-checkbox>
      <el-checkbox v-model="filter.displayCouponType" @change="search_fn">引換券・割引券の内訳を表示</el-checkbox>
      <el-checkbox v-model="filter.displayNoBoxOffice" @change="search_fn">無料動員（招待券など）を含む</el-checkbox>
      <el-checkbox v-model="filter.displaySamePrice">{{ $locale('trans.report.displaySamePrice') }}</el-checkbox>
    </div>
    <div id="print">
      <div class="table-module info-supplement-container daily-time">
        <el-row class="info-summary daily-time-item">
          <el-col :span="6">{{ $locale('trans.report.period') }}：{{ searchDate }}</el-col>
          <el-col :span="6">{{ $locale('trans.report.generatedate') }}：{{ searchTime }}</el-col>
          <el-col :span="6">{{ $locale('global.titleOfWork') }}：{{ filmName }}</el-col>
          <el-col :span="6">バージョン：{{ versionText }}</el-col>
        </el-row>
        <el-row class="info-summary daily-time-item">
          <el-col :span="6">{{ $locale("report.saleWeekly.publicWeek") }}：{{ weekTime }}</el-col>
          <el-col :span="6">{{ $locale("report.saleWeekly.submissionDestination") }}：{{ distributor }}</el-col>
          <el-col :span="6">{{ $locale('global.cinemaName') }}：{{ cinemaName }}</el-col>
          <el-col :span="6">{{ $locale("report.saleWeekly.brandName") }}：{{ brandName }}</el-col>
        </el-row>
      </div>
    
      <div class="report-table custom-border-table">
      <div class="table-scroll-box">
        <div class="table-scroll-body" v-if="tableData.length > 0">
          <el-table
            ref="tableRef"
            :data="tableData"
            class="egl-table sale-weekly"
            :span-method="spanMethod"
            :row-class-name="setTrClassName"
            :cell-class-name="setTdClassName"
            @sort-change="sortAdmissionFees"
          >
            <template v-for="th in thead">
              <el-table-column
                v-if="!th.isDouble"
                :label="th.label"
                :prop="th.prop"
                :width="th.width"
                :key="th.label"
                :sortable="th.sort"
                
              ></el-table-column>
              <el-table-column
                v-else
                :label="th.label"
                :width="th.width"
                :key="th.label"
              >
                <template slot-scope="scope">
                  <template v-if="typeof(scope.row[th.prop]) == 'string'">
                    {{ scope.row[th.prop] }}
                  </template>
                  <template v-else-if="scope.row[th.prop]">
                    <div>{{ scope.row[th.prop][0] }}</div>
                    <div>{{ scope.row[th.prop][1] }}</div>
                  </template>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommDatePicker from "@/components/common/CommDatePicker";
import { getMovieWeeklySaleReport, getFilmList } from "@/helpers/service/api/report";
import { getVersion, getOtherVersion } from "@/helpers/service/api/common.js";
import { weekLocaleArray } from "@/utils/common";
import "@/assets/style/saleWeekly.less";
import { getExportName_fn } from '@/utils/common'

import filterOptions from "@/mixins/filterOptions";
import { localStorage } from '@/utils/localStorage'
import { saveFilterOptions } from "@/utils/filterOptions";

export default {
  name: "SaleWeeklyDaily",
  mixins: [ filterOptions ],
  data() {
    return {
      printObj: {
        popTitle: this.$locale("sideMenu.reports.filmRevenueWeekly"),
        id: "print"
      },
      filter: {
        date: 0,
        displayCouponType: true,// 引換券・割引券の内訳を表示
        displayNoBoxOffice: true,// 無料動員（招待券など）を含む
        displayNoTicketType: true,// 取引のない券種を表示
        displaySamePrice: false,
        filmId: "",

        versions: [],
        otherVersions: [],
        subtitlesVersions: [],
      },
      cinemaId: "",
      cinemaName: "",
      filmOption: [],
      versionOption: [],
      subtitlesVersionOption: [
        {
          text: this.$locale("global.subtitlesVersion.NONE"),
          value: "NONE"
        },
        {
          text: this.$locale("global.subtitlesVersion.SUBTITLE"),
          value: "SUBTITLE"
        },
        {
          text: this.$locale("global.subtitlesVersion.DUB"),
          value: "DUB"
        }
      ],
      otherVersionOption: [],
      searchDate: "",
      searchTime: "",
      filmName: "",
      versionText: "",
      weekTime: "",
      distributor: "",
      brandName: "",
      tableData: [],
      thead: [],
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      originData: [],
    };
  },
  methods: {
    search_fn() {
      saveFilterOptions({
        id: localStorage.get('loginAsAccountId') || localStorage.get('accountId'),
        options: {
          filter: this.$_.omit(this.filter, ['date', 'filmId']),
        }
      }, 'sale-weekly')
      const that = this;
      let obj = { ...this.filter, cinemaId: that.cinemaId };

      obj.date = that.$moment(obj.date).format("YYYY-MM-DD");

      if (this.$refs.tableRef) {
        this.$refs.tableRef.clearSort();
      }

      if (obj.filmId) {
        getMovieWeeklySaleReport(obj).then(res => {
          if (res.success) {
            const tableData = that.formatTableData(res.data);
            const searchDate = `${that.$moment(res.data.reportOf.start).format("YYYY/MM/DD")}(${weekLocaleArray[that.$moment(res.data.reportOf.start).day()]}) 〜 ${that.$moment(res.data.reportOf.end).format("YYYY/MM/DD")}(${weekLocaleArray[that.$moment(res.data.reportOf.end).day()]})`;
            let versionText = res.data.movieDetail.version;
            let thead = that.createTableHeader();

            // obj.versions.map(versionId => {
            //   for (let i = 0; i < that.versionOption.length; i++) {
            //     if (that.versionOption[i].id == versionId) {
            //       versionText = versionText + that.versionOption[i].name + "/";
            //       break;
            //     }
            //   }
            // });

            // versionText = versionText.length > 0 ? versionText.substring(0, versionText.length - 1) : versionText;

            for (let i = 0; i < 7; i++) {
              let dayTime = res.data.reportOf.start + i * 24 * 60 * 60 * 1000;

              thead.push({
                prop: "col" + (i + 4),
                label: `${that.$moment(dayTime).format("YYYY/MM/DD")}(${weekLocaleArray[that.$moment(dayTime).day()]})`,
                width: "160",
                isDouble: true,
                align: "right",
              });
            }

            thead.push(
              {
                prop: "col11",
                label: that.$locale("report.saleWeekly.weekTotal"),
                width: "200",
                isDouble: true,
                align: "right",
              },
              {
                prop: "col12",
                label: that.$locale("trans.report.subtotal"),
                width: "200",
                isDouble: true,
                align: "right",
              }
            );

            that.searchDate = searchDate;
            that.searchTime = that.$moment().format("YYYY/MM/DD HH:mm:ss");
            that.filmName = res.data.movieDetail.movie;
            that.versionText = versionText;
            that.weekTime = res.data.movieDetail.week;
            that.distributor = res.data.movieDetail.distributor;
            that.brandName = res.data.brandName;
            that.tableData = tableData;
            that.originData = tableData;
            that.thead = thead;
          }
        }).catch(() => {});
      } else {
        this.$alert(this.$locale("report.saleWeekly.plsChooseMovie"));
      }
    },
    getDate(num) {
      this.filter = {
        ...this.filter,
        date: num
      };
    },
    getAllMessage_fn() {
      const cinemaId = window.localStorage.getItem("cinemaId") || "";
      let cinemaObj = window.localStorage.getItem("cinemaObj") || "";
      let cinemaName = "";

      if (cinemaId != "") {
        cinemaObj = JSON.parse(cinemaObj);
        for (let i = 0; i < cinemaObj.length; i++) {
          if (cinemaObj[i].id == cinemaId) {
            cinemaName = cinemaObj[i].name;
            break;
          }
        }
      } else {
        this.$emit("callCinema", "getAllMessage_fn");

        return;
      }

      this.cinemaId = cinemaId;
      this.cinemaName = cinemaName;
      this.getFilmList_fn();
      this.getVersion_fn();
      this.getOtherVersion_fn();
    },
    getFilmList_fn() {
      getFilmList({ cinemaId: this.cinemaId, startDate: this.$moment(this.filter.date).format("YYYY-MM-DD")}).then(res => {
        if (res.success) {
          this.filmOption = res.data || [];
        }
      });
    },
    getVersion_fn() {
      getVersion({ cinemaId: this.cinemaId, page: 0, pageSize: 9999 }).then(res => {
        if (res.success) {
          this.versionOption = res.data.data;
        }
      });
    },
    getOtherVersion_fn() {
      getOtherVersion({ cinemaId: this.cinemaId, page: 0, pageSize: 9999 }).then(res => {
        if (res.success) {
          this.otherVersionOption = res.data.data;
        }
      });
    },
    formatTableData(obj) {
      const that = this;
      const keyNames = [ "boxOffice", "morningShow", "lateShow", "allNight", "special" ];
      const keyNames_str = [ "本興行", "モーニングショー", "レイトショー", "オールナイト", "特別興行" ];// do some thing
      const priceUnit_str = that.$locale("global.circle");
      let tableData = [];
      let totalTable = [];
      let dayTotal = {
        col3: that.$locale("report.saleWeekly.dayTotal"),

        isTotalTr: true,
        trType: "total",
      };
      let invitationTotal = {
        col3: that.$locale("report.saleWeekly.invitationTotal"),

        isTotalTr: true,
        trType: "total",
      };
      let miniTable = [
        {
          col10: "",
          col11: that.$locale("report.saleWeekly.monthTotal"),
          col12: [ obj.monthlyAccumulated.visitor.toLocaleString(), obj.monthlyAccumulated.total.toLocaleString() + priceUnit_str ],
          isTotalTr: true,
          trType: "mini",
        },
        {
          col10: "",
          col11: that.$locale("report.saleWeekly.cumulativeOoxOffice"),
          col12: [ obj.boxOfficeAccumulated.visitor.toLocaleString(), obj.boxOfficeAccumulated.total.toLocaleString() + priceUnit_str ],
          isTotalTr: true,
          trType: "mini",
        }
      ];
      let weatherTable = [ { isTotalTr: false, trType: "weather" }, { isTotalTr: false, trType: "weather" }, { isTotalTr: false, trType: "weather" } ];

      for (let i = 0; i < 9; i++) {
        dayTotal[`col${i + 4}`] = [
          obj.dayTotals[i].visitor.toLocaleString(),
          obj.dayTotals[i].total.toLocaleString() + priceUnit_str
        ];
        invitationTotal[`col${i + 4}`] = [ obj.invitations[i], 0 + priceUnit_str ];
        if (i > 6) {
        //   invitationTotal[`col${i + 4}`] = [ 0, 0 + priceUnit_str ];
          weatherTable[0][`col${i + 4}`] = 0;
          weatherTable[1][`col${i + 4}`] = 0;
        } else {
          // invitationTotal[`col${i + 4}`] = [ obj.invitations[i].toLocaleString(), 0 + priceUnit_str ];
          weatherTable[0][`col${i + 4}`] = [
            that.$locale("report.saleWeekly.weather"),
            obj.weekSalesHeaders[i].weather
          ];
          weatherTable[1][`col${i + 4}`] = obj.weekSalesHeaders[i].showCount + that.$locale("report.saleWeekly.showTime1");
        }

        weatherTable[2][`col${i + 4}`] = [
          that.$locale("report.saleWeekly.personnel"),
          that.$locale("global.amount")
        ];
      }

      keyNames.map((keyName, keyNameIndex) => {
        if (obj.weeklySalesRecords[keyName]) {
          if (obj.weeklySalesRecords[keyName].records.length > 0) {
            let keyNameIndexInTable = tableData.length;

            let totalTr = {
              col3: keyNames_str[keyNameIndex] + that.$locale("report.saleWeekly.total"),

              isTotalTr: true,
              trType: "data",
            };

            for (let i = 0; i < 9; i++) {
              totalTr[`col${i + 4}`] = [
                obj.weeklySalesRecords[keyName].totals[i].visitor.toLocaleString(),
                obj.weeklySalesRecords[keyName].totals[i].total.toLocaleString() + priceUnit_str
              ];
            }

            obj.weeklySalesRecords[keyName].records.map((item, itemIndex) => {
              let tdObj = {
                col0: keyNames_str[keyNameIndex],
                col1: item.ticketTypeName,
                col2: item.couponTypeName,
                col3: item.price.toLocaleString() + priceUnit_str,

                col11: [ item.overall.visitor.toLocaleString(), item.overall.total.toLocaleString() + priceUnit_str ],
                col12: [ item.accumulated.visitor.toLocaleString(), item.accumulated.total.toLocaleString() + priceUnit_str ],

                rowspan: 1,
                colspan: 1,

                isTotalTr: false,
                trType: "data",
              };

              for (let i = 0; i < 7; i++) {
                tdObj[`col${i + 4}`] = [
                  item.salesPerDay[i].detail.visitor.toLocaleString(),
                  item.salesPerDay[i].detail.total.toLocaleString() + priceUnit_str
                ];
              }

              if (itemIndex > 0) {
                tdObj.rowspan = 0;
                tdObj.colspan = 0;
              }

              tableData.push(tdObj);
            });
            tableData[keyNameIndexInTable].rowspan = obj.weeklySalesRecords[keyName].records.length;

            tableData.push({ ...totalTr });
            totalTable.push({ ...totalTr, trType: "total" });
          }
        }
      });

      tableData.push(
        {
          col0: "",
          trType: "null",
        },
        ...totalTable,
        dayTotal,
        {
          col0: "",
          trType: "null",
        },
        invitationTotal,
        {
          col0: "",
          trType: "null",
        },
        ...miniTable
      );
      tableData.unshift(
        ...weatherTable
      );

      return tableData
    },
    createTableHeader() {
      let arr = [
        {
          prop: "col0",
          label: this.$locale("report.saleWeekly.classification"),
          width: "80",
          isDouble: false,
          align: "left",
        },
        {
          prop: "col1",
          label: this.$locale("trans.report.ticketTypeName"),
          width: "180",
          isDouble: false,
          align: "left",
        },
        {
          prop: "col2",
          label: this.$locale("report.saleWeekly.couponVoucher"),
          width: "150",
          isDouble: false,
          align: "left",
        },
        {
          prop: "col3",
          label: this.$locale("report.saleWeekly.admissionFees"),
          width: "120",
          isDouble: false,
          align: "right",
          sort: 'custom',
        }
      ];

      return arr;
    },
    spanMethod({ rowIndex, columnIndex }) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };

      if (this.tableData[rowIndex].trType == "data" || this.tableData[rowIndex].trType == "total") {
        if (this.tableData[rowIndex].isTotalTr) {
          if (columnIndex <= 2) {
            obj.rowspan = 0;
            obj.colspan = 0;
          } else if (columnIndex == 3) {
            obj.colspan = 4;
          }
        } else {
          if (columnIndex == 0) {
            obj.rowspan = this.tableData[rowIndex].rowspan;
            obj.colspan = this.tableData[rowIndex].colspan;
          }
        }
      } else if (this.tableData[rowIndex].trType == "null") {
        if (columnIndex == 0) {
          obj.colspan = 13;
        } else {
          obj.rowspan = 0;
          obj.colspan = 0;
        }
      } else if (this.tableData[rowIndex].trType == "mini") {
        if (columnIndex == 10) {
          obj.colspan = 11;
        } else if (columnIndex > 10) {
          obj.colspan = 1;
        } else {
          obj.rowspan = 0;
          obj.colspan = 0;
        }
      } 
      else if (this.tableData[rowIndex].trType == "weather") {
        if (columnIndex == 3) {
          obj.colspan = 4;
        } else if (columnIndex > 3) {
          obj.colspan = 1;
        } else {
          obj.rowspan = 0;
          obj.colspan = 0;
        }
      }

      return obj
    },
    setTrClassName({ row, rowIndex }) {
      let className = "";

      switch (row.trType) {
        case "null":
          className = "null-tr";
          break;

        case "total":
          className = "total-tr";
          break;

        case "mini":
          className = "mini-tr";
          break;

        default:
          className = "";
          break;
      }

      if (rowIndex == this.tableData.length - 3) {
        className += " no-boder-bottom";
      }

      if (rowIndex == this.tableData.length - 2) {
        className += " bd-top";
      }

      return className
    },
    exportCSV() {
      if (this.tableData.length > 0) {
        // const fileName = `${this.$moment().format("YYYYMMDDHHmm")}_${this.$locale("sideMenu.reports.filmRevenueWeekly")}`;
        const fileName =
        getExportName_fn(
          this.$locale("sideMenu.reports.filmRevenueWeekly"),
          this.filmName,
          '',
          '',
          `${this.$moment(this.filter.date).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.date).day()]}）`,
          this.cinemaName,
          this.$moment().format('YYYYMMDDHHmm') + '.csv',
        )
        const tableData = [ ...this.csvData ];
        let str = "";
        
        // push title
        str += `${this.$locale("trans.report.period")}: ${this.searchDate},${this.$locale("trans.report.generatedate")}: ${this.searchTime},${this.$locale("global.titleOfWork")}: ${this.filmName},バージョン: ${this.versionText}`;
        str += "\n";

        str += `${this.$locale("report.saleWeekly.publicWeek")}: ${this.weekTime},${this.$locale("report.saleWeekly.submissionDestination")}: ${this.distributor},${this.$locale("global.cinemaName")}: ${this.cinemaName},${this.$locale("report.saleWeekly.brandName")}: ${this.brandName}`;
        str += "\n";
        str += "\n";

        this.thead.map((item, index) => {
          if (index < 4) {
            str = str + item.label + ",";
          } else {
            str = str + item.label + ",,";
          }
        });
        str = str.substring(0, str.length - 1);
        
        
        tableData.map(item => {
          let labelArr = [];

          str += "\n";

          for (let i = 0; i < 13; i++) {
            if (i < 4) {
              labelArr[i] = item[`col${i}`] || "";
              labelArr[i] = labelArr[i].replace(/,/g, "");
            } else {
              if (item[`col${i}`]) {
                if (typeof(item[`col${i}`]) == "string") {
                  labelArr[i] = item[`col${i}`] + ",";
                } else if (typeof(item[`col${i}`]) == "object") {
                  let str1 = item[`col${i}`][0].toString().replace(/,/g, "");
                  let str2 = item[`col${i}`][1].toString().replace(/,/g, "");
                  labelArr[i] = str1 + "," + str2;
                }
              } else {
                labelArr[i] = ",";
              }
            }
          }

          str += labelArr.toString();
        });
        // json2csv_fn(this.tabl, [], fileName)
        if (navigator.msSaveOrOpenBlob) {
          let BOM = "\uFEFF";
          let blob = new  Blob([BOM + str], { type: "text/csv;charset=utf-8;"});
          navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + encodeURIComponent(str);
          let link = document.createElement("a");
          link.href = csvContent;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    dateDisableDate(time) {
      const _today = this.$moment().startOf("day").valueOf();
      const _curTime = this.$moment(time.getTime()).startOf("day").valueOf();
      return _curTime > _today;
    },
    setTdClassName({ row, column, columnIndex, rowIndex}) {
      let num = this.tableData.every(item => !item['col2']) ? 2 : 1
      // console.log(column)
      // return "sale-weekly-td-" + (columnIndex + (!column.property ? num : 1))
      return "sale-weekly-td-" + (columnIndex + 1)
    },
    isDisplayColumn(prop) {
      if (prop === 'col2' && this.tableData.every(item => !item[prop])) {
        // console.log(prop)
        return false
      }
      return true
    },
    selectOtherVersionsHandler(val) {
      if (val.indexOf('none') > -1) {
        this.filter.otherVersions = ['none']
      }
    },
    sortAdmissionFees({ column, prop, order }) {
      if (!order) {
        this.tableData = this.originData;
        return;
      }
      // console.log(column, prop, order);
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      const headData = this.$_.slice(tableData, 0, 3);
      const footData = this.$_.slice(tableData.filter((item) => item.trType === 'total' || item.trType === 'null' || item.trType === 'mini'));
      
      const start = 3;
      const end = tableData.length - footData.length;
      
      const allSortData = this.$_.slice(tableData, start, end);
      const sortData = this.$_.slice(tableData, start, end).filter((item) => item.col0);

      // 小合计
      const boxOfficeTotal = allSortData.find((item) => item.col3 === '本興行計') || {};
      const morningShowTotal = allSortData.find((item) => item.col3 === 'モーニングショー計') || {};
      const lateShowTotal = allSortData.find((item) => item.col3 === 'レイトショー計') || {};
      const allNightTotal = allSortData.find((item) => item.col3 === 'オールナイト計') || {};
      const specialTotal = allSortData.find((item) => item.col3 === '特別興行計') || {};

      // 小合计mapping
      const totalMapping = {
        '本興行': boxOfficeTotal,
        'モーニングショー': morningShowTotal,
        'レイトショー': lateShowTotal,
        'オールナイト': allNightTotal,
        '特別興行': specialTotal
      }

      const groupData = this.$_.groupBy(sortData, 'col0');
      let arr = []
      
      // 循环所有类别 分别进行排序
      Object.keys(groupData).forEach((key) => {
        let _data = groupData[key];
        
        _data.forEach((item, idx) => {
          // 将金额转为数字
          item.col3 = parseInt(item.col3.replace(/,|円/g, ''), 10);
        })
        if (order === 'descending') {
          _data = this.$_.reverse(this.$_.sortBy(_data, 'col3'));
          _data.forEach((item, idx) => {
            if (idx === 0) {
              item.colspan = 1;
              item.rowspan = _data.length
            } else {
              item.colspan = 0;
              item.rowspan = 0;
            }
            item.col3 = item.col3.toLocaleString() + '円';
          });
          arr.push(_data);
        } else if (order === 'ascending') {
          _data = this.$_.sortBy(_data, 'col3');
          _data.forEach((item, idx) => {
            if (idx === 0) {
              item.colspan = 1;
              item.rowspan = _data.length
            } else {
              item.colspan = 0;
              item.rowspan = 0;
            }
            item.col3 = item.col3.toLocaleString() + '円';
          });
          arr.push(_data);
        } else {
          arr = this.originData;
        }
        // 添加小合计
        if (totalMapping[key]) {
          arr.push(totalMapping[key]);
        }

      })
      arr = this.$_.flattenDeep(arr);
      // 重组tableData
      this.tableData = [...headData, ...arr, ...footData];
    }
  },
  mounted() {
    const today = this.$moment().valueOf();
    // let subtitlesVersionOption = [];
    let dictionary = window.localStorage.getItem("dictionary") || "";

    if (dictionary != "") {
      dictionary = JSON.parse(dictionary);

      // Object.keys(dictionary.ticketing.VersionType).map(keyName => {
      //   subtitlesVersionOption.push({
      //     value: keyName,
      //     label: keyName
      //   });
      // });
    }

    this.filter = {
      ...this.filter,
      date: today
    };
    this.loadOptions('sale-weekly', (val) => {
      this.filter = {
        ...this.filter,
        ...val.options.filter
      }
    })
    // this.subtitlesVersionOption = subtitlesVersionOption;
    this.getAllMessage_fn();
  },
  components: {
    CommDatePicker,
  },
  computed: {
    csvData() {
      let _arr = JSON.parse(JSON.stringify(this.tableData));
      _arr.forEach(item => {
        Object.keys(item).forEach(key => {
          if(key.indexOf("col") > -1) {
            if (typeof item[key] === "object") {
              item[key].forEach((colData, idx) => {
                item[key][idx] = colData.toString().replace("円", "");
              });
            } else {
              item[key] = item[key].toString().replace("円", "");
            }
          }
        });
      });
      return _arr;
    }
  },
  watch: {
    "filter.date"(newVal, oldVal) {
      if (newVal != oldVal && oldVal != 0) {
        this.filter.filmId = "";
        this.getFilmList_fn();
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .sale-weekly {
    ::v-deep th, ::v-deep td {
      padding: 0 !important;
    }
  }
  .sale-weekly .egl-table {
    ::v-deep tr.mini-tr td {
      padding: 0!important;
    }
  }
</style>
